<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" :items="items" />

                <!-- /product list -->
                <div class="card">
                    <div class="card-body">
                        <!-- <div class="table-top ">
                        </div> -->
                        <div class="d-flex align-items-center gap-3 mb-3">

                            <div class="search-set">
                                <!-- <div class="search-path">
                                    <a class="btn btn-filter" id="filter_search" v-on:click="filter = !filter"
                                        :class="{ setclose: filter }">
                                        <img src="../../../assets/img/icons/filter.svg" alt="img" />
                                        <span><img src="../../../assets/img/icons/closes.svg" alt="img" /></span>
                                    </a>
                                </div> -->
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="../../../assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="wordset">
                                <ul>
                                    <li class="">
                                        <router-link data-bs-toggle="tooltip" data-bs-placement="top" title="Import"
                                            class=" d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1"
                                            to="importemployee" style=" margin-bottom: 0px !important;">
                                            <img src="../../../assets/img/import-from-excel.png" alt="img" width="25" />
                                            <!-- <vue-feather
                                                type="upload" class="text-success"></vue-feather> 
                                                <span class="text-black">Import</span> -->
                                            </router-link>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                                            @click="export_employee"
                                            class="d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1">
                                            <img
                                                src="../../../assets/img/Import_fill.png" alt="img" width="25" /> 
                                                <!-- <span
                                                class="text-black">
                                                excel
                                            </span> -->
                                        </a>
    
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="sync"
                                            @click="sync_employee"
                                            v-if="isanviz != '' || isadms"
                                            class="d-flex flex-column justify-content-center align-items-center btn btn-primary p-1"
                                            :disabled="isSyncing" :style="isSyncing ? 'pointer-events: none; cursor: default;' : 'pointer-events: auto; cursor: pointer;'"> <!-- Make sure clickable is off when disabled -->
                                            
                                            <template v-if="isSyncing">
                                                <div class="spinner-border spinner-border-sm text-light" style="padding: 10px" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </template>
                                            
                                            <template v-else>
                                                <vue-feather type="repeat" style="color: white;"></vue-feather>
                                            </template>
                                        </a>
                                    </li>

    
                                </ul>
                            </div>
                        </div>
                        
                        <!-- /Filter -->
                         <!-- :scroll="{ x: 1500 }" -->
                        <div class="table-responsive">
                            <a-table :columns="columns" :data-source="filteredData" @change="handleTableChange" :pagination="pagination" :loading="loading">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname" @click="edit(record); goPage('editemployee');">
                                            {{ record.no }}
                                        </div>
                                    </template>
                                    
                                    <template v-if="column.key === 'nama_lokasi'">
                                        <div class="" >
                                            <!---<a href="javascript:void(0);" class="product-img">
                                                <img :src="require('../../../assets/img/product/' + record.img)"
                                                    alt="product" />
                                            </a>-->
                                            <a href="javascript:void(0);" class="link-click" @click="edit(record); goPage('editemployee');">{{ record.nama_lokasi }}</a>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'employee_id2'">
                                        <div class="" >
                                            <!---<a href="javascript:void(0);" class="product-img">
                                                <img :src="require('../../../assets/img/product/' + record.img)"
                                                    alt="product" />
                                            </a>-->
                                            <a href="javascript:void(0);" class="link-click" @click="edit(record); goPage('editemployee');">{{ record.employee_id2 }}</a>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'nama'">
                                        <div class="d-flex align-items-center gap-2" >
                                            <div class="product-img" >
                                                <img :src="record.foto_ktp" :alt="record.nama" style=" object-fit: cover; border-radius: 50%;" />
                                            </div>
                                            <a href="javascript:void(0);" class="link-click" @click="edit(record); goPage('editemployee');">
                                                {{ record.nama }}
                                            </a>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'telepon'">
                                        <div class="link-click" @click="edit(record); goPage('editemployee');">
                                            {{ record.telepon }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'tipe_kerja'"  >
                                        <div class="link-click" @click="edit(record); goPage('editemployee');">
                                            {{ record.tipe_kerja }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'nama_departemen'">
                                        <div class="productimgname" >
                                            <span v-if="record.nama_departemen == 0">-</span>
                                            <span v-else>{{ record.nama_departemen }}</span>

                                        </div>
                                    </template>

                                    <template v-if="column.key === 'nama_jabatan'"  >
                                        <div class="productimgname" >
                                            <span v-if="record.nama_jabatan == 0">-</span>
                                            <span v-else>{{ record.nama_jabatan }}</span>

                                        </div>
                                    </template>
                                    
                                    
                                    <template v-else-if="column.key === 'action'">
                                        <!-- <a class="me-3" @click="show_izitoast">
                                            <img src="../../../assets/img/icons/eye.svg" alt="img" />
                                        </a> -->
                                        <a v-if="this.companyType === 'company'" class="text-primary me-3" href="javascript:void(0);"
                                            @click="mutasi(record.id); showModal('mutasi');">
                                            <vue-feather type="corner-up-right"></vue-feather>
                                        </a>
                                        <a v-if="isadms && String(record.jenis_absensi || '').toUpperCase() === 'FINGERPRINT'" class="text-primary me-3"
                                            href="javascript:void(0);" title="Enroll Finger" aria-label="Enroll Finger" @click="openEnroll(record)">
                                            <i class="fas fa-fingerprint" style="font-size: 20px;" aria-hidden="true"></i>
                                        </a>
                                        <router-link class="me-3" to="editemployee" @click="edit(record);">
                                            <img src="../../../assets/img/icons/edit.svg" alt="img" />
                                        </router-link>
                                        <a class="confirm-text" href="javascript:void(0);"
                                            @click="terminate(record.id); showModal('terminate');">
                                            <img src="../../../assets/img/icons/delete.svg" alt="img" />
                                        </a>

                                    </template>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
    <!-- <button type="button" class="btn btn-primary" @click="">
        Launch demo modal
    </button> -->

    <div class="modal fade" id="terminate" ref="terminate" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Employee Terminate</h5>
                    <button type="button" class="close" @click="hideModal2('terminate')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="delete2">
                    <div class="modal-body">
                        <div class="form-group d-flex flex-column gap-2">
                            <div class="input-groupicon" style="z-index: 100;">
                                <datepicker v-model="tanggal_terminate" class="picker" :editable="true"
                                    :clearable="false" required />
                                <a class="addonset">
                                    <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                            </div>
                            <div>
                                <textarea class="form-control" placeholder="Write terminate reason in here"
                                    v-model="alasan_terminate" required />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <!-- <button type="button" class="btn btn-sm btn-secondary" @click="hideModal2('terminate')">cancel</button> -->
                        <button type="submit" class="btn btn-sm btn-danger">Terminate</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="modal fade" id="mutasi" ref="mutasi" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Employee Transfer</h5>
                    <button type="button" class="close" @click="hideModal2('mutasi')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="mutasi_data">
                    <div class="modal-body">
                        <div class="form-group d-flex flex-column gap-2">
                            <!-- <div class="input-groupicon" style="z-index: 100;">
                                <datepicker v-model="tanggal_terminate" class="picker" :editable="true"
                                    :clearable="false" required />
                                <a class="addonset">
                                    <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                                </a>
                            </div> -->
                            <div >
                                <vue-select :options="tujuanMutasiList"
                                    :settings="{ settingOption: value, settingOption: value }"
                                    v-model="id_tujuan_mutasi" placeholder="Choose Location" required>
                                </vue-select>
                            </div>
                            <div>
                                <textarea class="form-control" placeholder="Write transfer reason in here"
                                    v-model="alasan_terminate" required />
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="submit" class="btn btn-sm btn-danger">mutasi</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- Enroll sidik jari ke mesin ADMS -->
    <div class="modal fade" id="enroll" ref="enroll" tabindex="-1" role="dialog" aria-labelledby="enrollTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="enrollTitle">Enroll Finger - {{ enroll.nama }} ({{ enroll.pin }})</h5>
                    <button type="button" class="close" @click="closeEnroll" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body d-flex flex-column gap-3">
                    <div v-if="enroll.loading">Memuat mesin...</div>
                    <template v-else>
                        <div class="form-group mb-0">
                            <label for="enrollMachine">Mesin</label>
                            <select id="enrollMachine" class="form-control" v-model="enroll.device_id" :disabled="enroll.polling">
                                <option v-for="m in enroll.machines" :key="m.device_id" :value="m.device_id">
                                    {{ m.nama ? m.nama + ' (' + m.sn + ')' : m.sn }} - {{ m.online ? 'online' : 'OFFLINE' }} - jari terdaftar: {{ m.enrolled_fingers.length }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group mb-0">
                            <label for="enrollFinger">Jari</label>
                            <select id="enrollFinger" class="form-control" v-model="enroll.finger" :disabled="enroll.polling">
                                <option value="">Otomatis (jari yang masih kosong)</option>
                                <option v-for="(label, i) in fingerLabels" :key="i" :value="String(i)">{{ i }} - {{ label }}</option>
                            </select>
                        </div>
                        <div v-if="enroll.message" role="status" :class="enroll.statusClass">{{ enroll.message }}</div>
                    </template>
                </div>
                <div class="modal-footer d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-sm btn-secondary" @click="closeEnroll">Tutup</button>
                    <button type="button" class="btn btn-sm btn-primary" @click="startEnroll"
                        :disabled="enroll.loading || enroll.polling || !enroll.device_id || !selectedMachineOnline">
                        {{ enroll.polling ? 'Menunggu...' : 'Mulai Enroll' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.ant-tooltip {
    display: none !important;
}
.ant-table-cell {
    cursor: pointer !important;
}
.link-click {
  color: black;
  text-decoration: none;
}
.link-click:hover {
    color: #08b77e;
    text-decoration: underline;
}
</style>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import {  ErrorConnectionTimeOut, base_url, AlertPopup2, AlertBottom, goPage, appendForm, timeout, selectedBranch} from "@/assets/js/function";

import { watch } from "vue";


export default {
    data() {
        return {
            filter: false,
            title: "Employee List",
            title1: "Manage your employee",
            items: [
                {
                    text: "Add New Employee",
                    addname: "/addemployee",
                },
            ],
            data: [
            ],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    fixed: 'left',
                    // width: 60,
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                
                {
                    title: "Name",
                    dataIndex: "nama",
                    key: "nama",
                    fixed: 'left',
                    // width: 280,
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama.toLowerCase();
                            b = b.nama.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Employee Id",
                    dataIndex: "employee_id2",
                    key: "employee_id2",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.employee_id2.toLowerCase();
                            b = b.employee_id2.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Finger ID",
                    dataIndex: "employee_id",
                    key: "employee_id",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.employee_id.toLowerCase();
                            b = b.employee_id.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "No KTP",
                    dataIndex: "no_ktp",
                    key: "no_ktp",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.no_ktp.toLowerCase();
                            b = b.no_ktp.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Bisnis Unit ",
                    dataIndex: "nama_lokasi",
                    key: "nama_lokasi",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_lokasi.toLowerCase();
                            b = b.nama_lokasi.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Department",
                    dataIndex: "nama_departemen",
                    key: "nama_departemen",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_departemen.toLowerCase();
                            b = b.nama_departemen.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Job Title",
                    dataIndex: "nama_jabatan",
                    key: "nama_jabatan",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_jabatan.toLowerCase();
                            b = b.nama_jabatan.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Join Date",
                    dataIndex: "join_date",
                    key: "join_date",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.join_date.toLowerCase();
                            b = b.join_date.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "DOB",
                    dataIndex: "dob",
                    key: "dob",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.dob.toLowerCase();
                            b = b.dob.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Whatsapp",
                    dataIndex: "telepon",
                    key: "telepon",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.telepon.toLowerCase();
                            b = b.telepon.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Email",
                    dataIndex: "email",
                    key: "email",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.email.toLowerCase();
                            b = b.email.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Employee Status",
                    dataIndex: "status_karyawan",
                    key: "status_karyawan",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.status_karyawan.toLowerCase();
                            b = b.status_karyawan.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Tipe Absensi",
                    dataIndex: "jenis_absensi",
                    key: "jenis_absensi",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.jenis_absensi.toLowerCase();
                            b = b.jenis_absensi.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Tempat Lahir",
                    dataIndex: "place_dob",
                    key: "place_dob",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.place_dob.toLowerCase();
                            b = b.place_dob.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Alamat",
                    dataIndex: "alamat",
                    key: "alamat",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.alamat.toLowerCase();
                            b = b.alamat.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Religion",
                    dataIndex: "agama",
                    key: "agama",
                    // width: 120,
                    sorter: {
                        compare: (a, b) => {
                            a = a.agama.toLowerCase();
                            b = b.agama.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Gender",
                    dataIndex: "jenis_kelamin",
                    key: "jenis_kelamin",
                    // width: 120,
                    sorter: {
                        compare: (a, b) => {
                            a = a.jenis_kelamin.toLowerCase();
                            b = b.jenis_kelamin.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Marital Status",
                    dataIndex: "marital_status",
                    key: "marital_status",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.marital_status.toLowerCase();
                            b = b.marital_status.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                
                
                
                {
                    title: "Action Trigger",
                    key: "action",
                    fixed: 'right', // to freeze at right
                    sorter: false,
                    // width: 200,

                },
            ],
            tanggal_terminate: new Date(),
            alasan_terminate: "",
            id_terminate: "",
            id_tujuan_mutasi: "",

            isanviz: "",
            isadms: false,
            // ZKTeco finger index 0-9 (dokumentasi ADMS)
            fingerLabels: ['Kelingking kiri', 'Manis kiri', 'Tengah kiri', 'Telunjuk kiri', 'Jempol kiri',
                'Jempol kanan', 'Telunjuk kanan', 'Tengah kanan', 'Manis kanan', 'Kelingking kanan'],
            enroll: { employee_id: null, nama: '', pin: '', machines: [], device_id: null, finger: '', loading: false, polling: false, message: '', statusClass: '' },
            enrollTimer: null,
            isSyncing: false,   // To show spinner and disable button

            currentData: {},
            query: "",
            tujuanMutasiList: [],

            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: false
            },

            loading: false,

            companyType: '',
            currentCompanyId: '',
        };
    },
    async created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        

        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        // await fetchMasterData();
        localStorage.setItem('actionState', 'view')

        await this.index();

    },

    mounted() {

        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })

        const savedPage = localStorage.getItem("lastPage");
        if (savedPage) {
            this.pagination.current = parseInt(savedPage);
        }
    },
    
    computed: {
        filteredData() {
            if (this.query == '') {
                return this.data;
            }
            const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison
            return this.data.filter(item =>
                item.nama.toLowerCase().includes(lowerCaseQuery) ||
                item.telepon.includes(this.query) ||
                item.tipe_kerja.toLowerCase().includes(lowerCaseQuery) ||
                item.nama_departemen.toLowerCase().includes(lowerCaseQuery) ||
                item.nama_jabatan.toLowerCase().includes(lowerCaseQuery) ||
                item.nama_shift.toLowerCase().includes(lowerCaseQuery) ||
                item.nama_lokasi.toLowerCase().includes(lowerCaseQuery) ||
                item.employee_id.toLowerCase().includes(lowerCaseQuery) ||
                item.employee_id2.toLowerCase().includes(lowerCaseQuery) 
            );
        },
        selectedMachineOnline() {
            const m = this.enroll.machines.find((x) => x.device_id === this.enroll.device_id);
            return !!(m && m.online);
        },
    },
    beforeUnmount() {
        clearInterval(this.enrollTimer);
    },
    methods: {
        enrollForm(action) {
            const formData = new FormData();
            appendForm(formData);
            formData.append('action', action);
            formData.append('employee_id', this.enroll.employee_id);
            if (this.enroll.device_id) formData.append('device_id', this.enroll.device_id);
            return formData;
        },
        setEnrollMessage(message, statusClass = 'text-muted') {
            this.enroll.message = message;
            this.enroll.statusClass = statusClass;
        },
        async openEnroll(record) {
            clearInterval(this.enrollTimer);
            this.enroll = { employee_id: record.id, nama: record.nama, pin: record.employee_id, machines: [], device_id: null, finger: '', loading: true, polling: false, message: '', statusClass: '' };
            this.showModal('enroll');

            const res = await axios.post(base_url + '/v3/adms/enroll', this.enrollForm('machines'), { timeout });
            this.enroll.loading = false;
            if (!res.data.status) return this.setEnrollMessage(res.data.message, 'text-danger');

            this.enroll.machines = res.data.data.machines;
            const first = this.enroll.machines.find((m) => m.online) || this.enroll.machines[0];
            this.enroll.device_id = first ? first.device_id : null;
            if (!this.selectedMachineOnline) this.setEnrollMessage('Mesin offline. Enroll hanya bisa saat mesin online.', 'text-danger');
        },
        async startEnroll() {
            const formData = this.enrollForm('start');
            formData.append('finger', this.enroll.finger);
            const res = await axios.post(base_url + '/v3/adms/enroll', formData, { timeout });
            if (!res.data.status) return this.setEnrollMessage(res.data.message, 'text-danger');

            this.setEnrollMessage(res.data.message);
            this.enroll.polling = true;
            const startedAt = Date.now();
            // Status dicek tiap 5 detik; layar muncul di mesin pada check-in berikutnya (~1 menit)
            this.enrollTimer = setInterval(async () => {
                if (Date.now() - startedAt > 4 * 60 * 1000) {
                    clearInterval(this.enrollTimer);
                    this.enroll.polling = false;
                    return this.setEnrollMessage('Belum ada respons dari mesin. Pastikan mesin online, lalu coba lagi.', 'text-danger');
                }
                const r = await axios.post(base_url + '/v3/adms/enroll', this.enrollForm('status'), { timeout }).catch(() => null);
                const status = r && r.data.status && r.data.data.enrollment ? r.data.data.enrollment.status : null;
                if (status === 'waiting') this.setEnrollMessage('Layar enroll sudah tampil di mesin. Tempelkan jari sesuai petunjuk mesin.', 'text-primary');
                if (['enrolled', 'timeout', 'failed'].includes(status)) {
                    clearInterval(this.enrollTimer);
                    this.enroll.polling = false;
                    if (status === 'enrolled') this.setEnrollMessage('Berhasil: sidik jari tersimpan di mesin.', 'text-success');
                    if (status === 'timeout') this.setEnrollMessage('Waktu habis: tidak ada jari yang ditempel. Klik Mulai Enroll lagi.', 'text-danger');
                    if (status === 'failed') this.setEnrollMessage('Gagal: mesin menolak (kode ' + (r.data.data.enrollment.code ?? '-') + '). Coba lagi.', 'text-danger');
                }
            }, 5000);
        },
        closeEnroll() {
            clearInterval(this.enrollTimer);
            this.enroll.polling = false;
            this.hideModal2('enroll');
        },
        goPage,
        showModal(modal_name) {
        
            const modal = this.$refs[modal_name];
            
            // Show modal
            modal.classList.add('show');
            modal.style.display = 'block';

            // Add backdrop manually
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            backdrop.setAttribute('data-modal-backdrop', modal_name); // optional attribute to identify
            document.body.appendChild(backdrop);

            // Prevent body scroll
            document.body.classList.add('modal-open');
        },
        hideModal2(modal_name) {
            const modal = this.$refs[modal_name];
            
            // Hide modal
            modal.classList.remove('show');
            modal.style.display = 'none';
    
            // Remove backdrop
            const backdrop = document.querySelector(`.modal-backdrop[data-modal-backdrop="${modal_name}"]`);
            if (backdrop) backdrop.remove();
    
            // Remove scroll lock
            document.body.classList.remove('modal-open');
        },

        handleTableChange(pagination) {
            this.pagination = pagination; // keep pagination reactive
            localStorage.setItem("lastPage", pagination.current);
        },

        async sync_employee() {
            this.isSyncing = true;
           
             try {
                // Simulate API or real sync function
                
                let formData = new FormData();
                appendForm(formData)
                
                for (let [key, value] of formData.entries()) {
                    console.log(key, value);
                }
                // CloseLoading()
                // return;
                
                // Company dengan mesin ADMS sync ke ADMS; selain itu ke Anviz (keduanya tidak bisa aktif bersamaan)
                const api = this.isadms ? base_url + '/v3/adms/employee_sync' : base_url + '/v3/applications/anviz_sync?appname=anviz';
                const res = await axios.post(api, formData, { timeout });
                // console.log("INI DATA sync employee", res);
                const data = res.data;
                


                if(data.status){
                    AlertBottom(data.message);
                }else {
                    AlertPopup2("error", "", data.message, true, 1500);

                }

            } catch (error) {
                console.error('Sync failed', error);
            } finally {
                this.isSyncing = false;
            }
            
           
            

        },

        async index() {
            this.loading = true;

            const formData = new FormData();
            appendForm(formData);

            // const cache = localStorage.getItem("employeeList");
            // const cacheLocation = localStorage.getItem("locationMutasiList");
            // if (!cache) {
            //     console.warn("Data employeeList belum ada di localStorage.");
            //     return;
            // }
            // if (!cacheLocation) {
            //     console.warn("Data locationList belum ada di localStorage.");
            //     return;
            // }

            // formData.append("periode", this.formatDateLocal(this.periode));
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }

            const api = base_url + '/v3/employees/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data.data;
            const employee = data.data_employee  || []
            console.log("INI DATA EMPLOYEE", employee);
            // console.log("INI DATA full", data);

            

            // const result = JSON.parse(cache);
            // const location = JSON.parse(cacheLocation);
        

            this.data = [];
            employee.forEach((item, index) => {
                const item_prepare = {
                    ...item,
                    no: index + 1,
                    nama_departemen: item.nama_departemen || '-',
                    nama_jabatan: item.nama_jabatan || '-',
                    nama_shift: item.shift_id === 0 ? '-' : item.nama_shift || '-',
                    };
                this.data.push(item_prepare);
            });

            this.loading = false;

            localStorage.setItem('departemenList', JSON.stringify(data.data_departemen))
            localStorage.setItem('employeeList', JSON.stringify(data.data_employee))
            localStorage.setItem('jabatanList', JSON.stringify(data.data_jabatan))
            localStorage.setItem('shiftList', JSON.stringify(data.data_shift))
            localStorage.setItem('statusPajakList', JSON.stringify(data.data_status_pajak))
            localStorage.setItem('locationList', JSON.stringify(data.data_lokasi))
            localStorage.setItem('dataBranchList', JSON.stringify(data.data_lokasi_branch))

            this.currentCompanyId = localStorage.getItem('selectedBranch')
            this.tujuanMutasiList = data.data_lokasi
            .filter(item => item.id !== this.currentCompanyId)
            .map((item) => ({
                id: item.id,
                text: item.nama_lokasi,
            }));

            this.companyType = localStorage.getItem('company_type');

            this.isanviz = data.is_anviz;
            this.isadms = !!data.is_adms;

            
            
            // location.forEach((value) => {
            //     this.tujuanMutasiList.push({ id: value.id, text: value.nama_lokasi });
            // });
        },
        
        addNumberToObjects(objArray) {
            for (let i = 0; i < objArray.length; i++) {
                const newObj = { No: i + 1, ...objArray[i] };
                objArray[i] = newObj;
            }
            return objArray;
        },

        async export_employee() {
            const formData = new FormData();
            appendForm(formData);

            formData.append('user_type', localStorage.getItem('tipe_user'))

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            
            const api = base_url + 'v3/employees/export';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            
            console.log('INI HASI EKSPOR', data)
            if (data.status) {
                const fileUrl = data.data.file_report
                console.log('sukses', fileUrl)

                // Create a temporary link and trigger download
                const link = document.createElement('a');
                link.href = fileUrl;
                link.download = 'Employee.xlsx'; // You can set a default filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                
            } else {
                AlertPopup2("error", "", "Error exporting to excel", true, 1500);
            }
                

        },
        edit(record) {
            localStorage.setItem('currentEmployee', JSON.stringify(record));
        },

        formatDateLocal(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },

        async delete2() {
         
            const formData = new FormData();
            appendForm(formData)

            formData.append("id", this.id_terminate);
           
            formData.append("tanggal", this.formatDateLocal(this.tanggal_terminate));
            formData.append("alasan", this.alasan_terminate);

            for (let [key, value] of formData.entries()) {
              console.log(`${key}: ${value}`);
            }

            const api = base_url + '/v3/employees/delete';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            // console.log("INI DATA delete", data);

            if (data.status) {
               

                const index = this.data.findIndex((record) => record.id === this.id_terminate);
                this.data.splice(index, 1);
                AlertBottom(data.message);
                this.hideModal2('terminate');
                
            } else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

            


        },

        // formatDateLocal(date) {
        //     const year = date.getFullYear();
        //     const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
        //     const day = String(date.getDate()).padStart(2, "0");
        //     return `${year}-${month}-${day}`;
        // },

        mutasi_data() {
            if (this.id_tujuan_mutasi == "") {
                AlertPopup2("error", "", "please choose the location", true, 1500);
                return true;
            }
            let formData = new FormData();
            appendForm(formData)
            formData.append("employee_id", this.id_terminate);
            formData.append("company_id_tujuan", this.id_tujuan_mutasi);
            
           

            formData.append("tanggal_mutasi", this.formatDateLocal(this.tanggal_terminate));
            formData.append("alasan_mutasi", this.alasan_terminate);

            for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'v3/employees/mutation';
            } else {
                this.api = base_url + 'v3/employees/mutation';
            }

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    if (response.data.status == true) {
                        const index = this.data.findIndex((record) => record.id === this.id_terminate);
                        this.data.splice(index, 1);
                        AlertBottom(response.data.message);
                        this.hideModal2('mutasi');

                    }
                    if (response.data.status == false) {
                        AlertPopup2("error", "", response.data.message, true, 1500);
                    }
                })
                .catch((error) => {

                    ErrorConnectionTimeOut(error);
                });


        },
        terminate(id) {
            this.id_terminate = id;
            this.tanggal_terminate = new Date();
        },
        mutasi(id) {
            this.id_terminate = id;
            this.tanggal_terminate = new Date();
        }
    },
    name: "Employees",
    openNewTab(record) {
        localStorage.setItem("currentEmployee", JSON.stringify(record));
        window.open("/editemployee", "_blank");
    },
};
</script>
